import { FC } from 'react'
import { TextProps, Text } from '@maas-components/core'
import CustomTypography from './styles'

export const TypographyHeadlineProps = {
  fontSize: 'large',
  fontWeight: 'bold',
} as Partial<TextProps>

export const TypographySubheadingProps = {
  fontSize: 'medium',
  fontWeight: 'medium',
} as Partial<TextProps>

export const TypographyCaptionProps = {
  fontSize: 'small',
  fontWeight: 'regular',
} as Partial<TextProps>

export const TypographyLabelProps = {
  fontSize: 'default',
  fontWeight: 'medium',
} as Partial<TextProps>

export const TypographyHeadline: FC<TextProps> = ({ children, ...restProps }) => {
  return (
    <CustomTypography {...TypographyHeadlineProps} style={{ paddingBottom: '32px' }} {...restProps}>
      {children}
    </CustomTypography>
  )
}

export const TypographySubheading: FC<TextProps> = ({ children, ...restProps }) => {
  return (
    <CustomTypography
      {...TypographySubheadingProps}
      style={{ paddingBottom: '32px' }}
      {...restProps}
    >
      {children}
    </CustomTypography>
  )
}

interface IVariantMapping {
  [key: string]: Partial<TextProps>
}

const variantMapping: IVariantMapping = {
  h1: {
    fontSize: 'xxxlarge',
    fontWeight: 'bold',
  },
  h2: {
    fontSize: 'xxlarge',
    fontWeight: 'bold',
  },
  h3: {
    fontSize: 'xlarge',
    fontWeight: 'bold',
  },
  h4: {
    fontSize: 'large',
    fontWeight: 'bold',
  },
  h5: {
    fontSize: 'medium',
    fontWeight: 'bold',
  },
  h6: {
    fontSize: 'small',
    fontWeight: 'bold',
  },
  subtitle1: {
    fontSize: 'default',
    fontWeight: 'medium',
  },
  subtitle2: {
    fontSize: 'small',
    fontWeight: 'bold',
  },
  body1: {
    fontSize: 'default',
    fontWeight: 'regular',
  },
  body2: {
    fontSize: 'small',
    fontWeight: 'regular',
  },
  button: {
    fontSize: 'default',
    fontWeight: 'medium',
  },
  caption: {
    fontSize: 'xsmall',
    fontWeight: 'medium',
  },
  OVERLINE: {
    fontSize: 'default',
    fontWeight: 'medium',
  },
}

interface ICustomTextProps extends TextProps {
  variant?: keyof IVariantMapping
  component?: string
  mt?: number
  mb?: number
  ml?: number
  mr?: number
}

export const Typography: FC<ICustomTextProps> = ({
  children,
  variant,
  mt,
  mb,
  ml,
  mr,
  ...restProps
}) => {
  const textProps = variant ? variantMapping[variant] : {}
  const customStyles: React.CSSProperties = {}

  if (mt) {
    customStyles.marginTop = `${mt}%`
  }
  if (mb) {
    customStyles.marginBottom = `${mb}%`
  }
  if (ml) {
    customStyles.marginLeft = `${ml}%`
  }
  if (mr) {
    customStyles.marginLeft = `${mr}%`
  }

  return (
    <Text {...textProps} style={{ ...customStyles }} {...restProps}>
      {children}
    </Text>
  )
}
